<template>
  <div>
    <div class="com-page-title">
      <div class="inner">{{ $route.query.title }}</div>
    </div>
    <div class="com-card">
      <div class="com-card-title">{{ payload.name }}<span class="right-txt">{{ payload.price ? `¥${payload.price}` : '' }}</span></div>
      <div class="com-card-content">
        <div class="text-wrap">
          <div class="com-text-justify" v-html="payload.brief?.replace(/\n/gi, '<br>')"/>
          <template v-if="!payload.price">
            <br>
            <div class="van-hairline--bottom"/>
            <br>
            <p class="t1">{{ payload.name }}具体事项请联系净慈寺客堂（联系方式见页尾）。</p>
          </template>
        </div>
        <br>
        <template v-if="payload.price">
          <div class="van-hairline--bottom"/>
          <br>
          <div class="com-form-wrap">
            <van-form>
              <van-field
                class="field-yellow"
                v-model="formList[0]"
                label="尺寸规格"
                readonly
                colon
              />
              <van-field
                class="field-yellow"
                label="供奉位置"
                readonly
                colon
              >
                <template #input>
                  <DictionaryText typeCode="gongfengweizhi" :dictValue="payload.position"/>
                </template>
              </van-field>
            </van-form>
            <div class="com-form-submit">
              <DefaultBtn @click="$router.push({ path: 'record', query: { ...$route.query } })">登记信息</DefaultBtn>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
  import DictionaryText from '@/components/common/DictionaryText'

  export default {
    data() {
      return {
        formList: ['纸质斋条', '由寺院随机安排'],
        payload: {},
        date:''
      }
    },
    mounted() {
      this.getData()
    },
    methods: {
      // 详情
      getData() {
        this.$faWuApi.foShi.getChildDetail({
          id: this.$route.query.id
        }).then(res => {
          if (res.success) {
            this.payload = res.data
            this.date = this.payload.date ? this.payload.date : this.formList[1]
          }
        })
      }
    },
    components: {
      DictionaryText
    }
  }
</script>